import {
  fromInt2ii0rejb1w62w as fromInt,
  subtract2orl8z9upxd9l as subtract,
} from '../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  _Char___init__impl__6a9atx2gndcvjvc5pke as _Char___init__impl__6a9atx,
  Char__toInt_impl_vasixdnyockrdnmht5 as Char__toInt_impl_vasixd,
} from '../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { toByte4i43936u611k as toByte } from '../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { asUtf8ToByteArray29u89fcaeh9ki as asUtf8ToByteArray } from '../NonJvmPlatform.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var HEX_DIGIT_BYTES;
function readUtf8Line(_this__u8e3s4, newline) {
  _init_properties_Buffer_kt__ndcom8();
  var tmp;
  var tmp_0;
  if (newline > 0n) {
    // Inline function 'kotlin.Long.minus' call
    var tmp$ret$0 = subtract(newline, fromInt(1));
    var tmp_1 = _this__u8e3s4.a3x(tmp$ret$0);
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(13);
    var tmp$ret$1 = Char__toInt_impl_vasixd(this_0);
    tmp_0 = tmp_1 === toByte(tmp$ret$1);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    var result = _this__u8e3s4.b3x(subtract(newline, 1n));
    _this__u8e3s4.o3v(2n);
    tmp = result;
  } else {
    var result_0 = _this__u8e3s4.b3x(newline);
    _this__u8e3s4.o3v(1n);
    tmp = result_0;
  }
  return tmp;
}
function selectPrefix(_this__u8e3s4, options, selectTruncated) {
  selectTruncated = selectTruncated === VOID ? false : selectTruncated;
  _init_properties_Buffer_kt__ndcom8();
  var tmp0_elvis_lhs = _this__u8e3s4.m3v_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return selectTruncated ? -2 : -1;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var head = tmp;
  var s = head;
  var data = head.c3w_1;
  var pos = head.d3w_1;
  var limit = head.e3w_1;
  var trie = options.w3v_1;
  var triePos = 0;
  var prefixIndex = -1;
  navigateTrie: while (true) {
    var tmp1 = triePos;
    triePos = tmp1 + 1 | 0;
    var scanOrSelect = trie[tmp1];
    var tmp2 = triePos;
    triePos = tmp2 + 1 | 0;
    var possiblePrefixIndex = trie[tmp2];
    if (!(possiblePrefixIndex === -1)) {
      prefixIndex = possiblePrefixIndex;
    }
    var nextStep;
    if (s == null) {
      break navigateTrie;
    } else if (scanOrSelect < 0) {
      var scanByteCount = imul(-1, scanOrSelect);
      var trieLimit = triePos + scanByteCount | 0;
      $l$loop: while (true) {
        var tmp_0 = data;
        var tmp3 = pos;
        pos = tmp3 + 1 | 0;
        // Inline function 'okio.and' call
        var byte = tmp_0[tmp3] & 255;
        var tmp4 = triePos;
        triePos = tmp4 + 1 | 0;
        if (!(byte === trie[tmp4]))
          return prefixIndex;
        var scanComplete = triePos === trieLimit;
        if (pos === limit) {
          s = ensureNotNull(ensureNotNull(s).h3w_1);
          pos = s.d3w_1;
          data = s.c3w_1;
          limit = s.e3w_1;
          if (s === head) {
            if (!scanComplete)
              break navigateTrie;
            s = null;
          }
        }
        if (scanComplete) {
          nextStep = trie[triePos];
          break $l$loop;
        }
      }
    } else {
      var selectChoiceCount = scanOrSelect;
      var tmp_1 = data;
      var tmp5 = pos;
      pos = tmp5 + 1 | 0;
      // Inline function 'okio.and' call
      var byte_0 = tmp_1[tmp5] & 255;
      var selectLimit = triePos + selectChoiceCount | 0;
      $l$loop_0: while (true) {
        if (triePos === selectLimit)
          return prefixIndex;
        if (byte_0 === trie[triePos]) {
          nextStep = trie[triePos + selectChoiceCount | 0];
          break $l$loop_0;
        }
        triePos = triePos + 1 | 0;
      }
      if (pos === limit) {
        s = ensureNotNull(s.h3w_1);
        pos = s.d3w_1;
        data = s.c3w_1;
        limit = s.e3w_1;
        if (s === head) {
          s = null;
        }
      }
    }
    if (nextStep >= 0)
      return nextStep;
    triePos = -nextStep | 0;
  }
  if (selectTruncated)
    return -2;
  return prefixIndex;
}
function rangeEquals(segment, segmentPos, bytes, bytesOffset, bytesLimit) {
  _init_properties_Buffer_kt__ndcom8();
  var segment_0 = segment;
  var segmentPos_0 = segmentPos;
  var segmentLimit = segment_0.e3w_1;
  var data = segment_0.c3w_1;
  var i = bytesOffset;
  while (i < bytesLimit) {
    if (segmentPos_0 === segmentLimit) {
      segment_0 = ensureNotNull(segment_0.h3w_1);
      data = segment_0.c3w_1;
      segmentPos_0 = segment_0.d3w_1;
      segmentLimit = segment_0.e3w_1;
    }
    if (!(data[segmentPos_0] === bytes[i])) {
      return false;
    }
    segmentPos_0 = segmentPos_0 + 1 | 0;
    i = i + 1 | 0;
  }
  return true;
}
var properties_initialized_Buffer_kt_xv4xxe;
function _init_properties_Buffer_kt__ndcom8() {
  if (!properties_initialized_Buffer_kt_xv4xxe) {
    properties_initialized_Buffer_kt_xv4xxe = true;
    HEX_DIGIT_BYTES = asUtf8ToByteArray('0123456789abcdef');
  }
}
//region block: exports
export {
  rangeEquals as rangeEquals13q7f5dia0en,
  readUtf8Line as readUtf8Line36yidw3sdfobh,
  selectPrefix as selectPrefix5tb3rl5iltlw,
};
//endregion

//# sourceMappingURL=Buffer.mjs.map
